import { useState, useEffect } from 'react';
import { getTaxCases } from '../services/firestoreService';
import { TaxCase, UserProfile } from '../types';

interface UseClientTaxCasesResult {
  cases: TaxCase[];
  loading: boolean;
  error: string | null;
}

export const useClientTaxCases = (user: UserProfile | null): UseClientTaxCasesResult => {
  const [cases, setCases] = useState<TaxCase[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!user) {
      setCases([]);
      setLoading(false);
      return;
    }

    const fetchCases = async () => {
      setLoading(true);
      setError(null);
      try {
        const results = await getTaxCases(user.firmId || 'hannah-financial-demo', user);
        setCases(results);
      } catch (err) {
        console.error("Error loading tax cases:", err);
        setError("Failed to load tax cases.");
      } finally {
        setLoading(false);
      }
    };

    fetchCases();
  }, [user?.uid, user?.firmId]);

  return { cases, loading, error };
};
